import Vue from "vue";

type ModalCallbacks = {
  onConfirm?: () => void;
  onCustom?: () => void;
  onRedirectPage?: () => void;
};

type ModalPayload = ModalCallbacks & {
  isVisible?: boolean;
  message?: string;
  header?: string;
  title?: string;
  isOk?: boolean;
  textButton?: string;
  textCustom?: string;
  isShowCancel?: boolean;
};

type ModalState = Required<Omit<ModalPayload, keyof ModalCallbacks>> & {
  callbacks: ModalCallbacks;
};

export const modalState = Vue.observable<ModalState>({
  isVisible: false,
  message: "",
  header: "",
  title: "",
  isOk: true,
  textButton: "",
  textCustom: "",
  isShowCancel: false,
  callbacks: {},
});

const close = (): void => {
  modalState.isVisible = false;
};

export const modal = {
  show(payload: ModalPayload): void {
    modalState.isVisible = payload.isVisible ?? true;
    modalState.message = payload.message || "";
    modalState.header = payload.header || "";
    modalState.title = payload.title || "";
    modalState.isOk = payload.isOk !== undefined ? payload.isOk : true;
    modalState.textButton = payload.textButton || "";
    modalState.textCustom = payload.textCustom || "";
    modalState.isShowCancel = payload.isShowCancel || false;
    modalState.callbacks = {
      onConfirm: payload.onConfirm,
      onCustom: payload.onCustom,
      onRedirectPage: payload.onRedirectPage,
    };
  },

  close,

  confirm(): void {
    modalState.callbacks.onConfirm?.();
    close();
  },

  custom(): void {
    modalState.callbacks.onCustom?.();
    close();
  },

  redirectPage(): void {
    modalState.callbacks.onRedirectPage?.();
    close();
  },
};
